import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface ContainerProps {
  children: ReactNode;
  className?: string;
  size?: "sm" | "md" | "lg" | "xl" | "full";
  id?: string;
}

const Container = ({ children, className, size = "lg", id }: ContainerProps) => {
  const sizeClasses = {
    sm: "max-w-3xl",
    md: "max-w-5xl", 
    lg: "max-w-7xl",
    xl: "max-w-screen-2xl",
    full: "max-w-none"
  };

  return (
    <div 
      id={id}
      className={cn(
        "mx-auto px-4 sm:px-6 lg:px-8",
        sizeClasses[size],
        className
      )}>
      {children}
    </div>
  );
};

export default Container;